import { render, staticRenderFns } from "./UploadPDF.vue?vue&type=template&id=048ec318&scoped=true&"
import script from "./UploadPDF.vue?vue&type=script&lang=js&"
export * from "./UploadPDF.vue?vue&type=script&lang=js&"
import style0 from "./UploadPDF.vue?vue&type=style&index=0&id=048ec318&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048ec318",
  null
  
)

export default component.exports